/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_garbage': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.667 20',
    data: '<path pid="0" data-name="Path 17819" d="M2.035 18.643A1.816 1.816 0 003.867 20h6.936a1.816 1.816 0 001.831-1.357l1.369-13.31H.667zm7.968-11.31a.667.667 0 011.333 0l-.667 10a.667.667 0 11-1.333 0zm-3.333 0a.667.667 0 111.333 0v10a.667.667 0 11-1.333 0zm-2.667-.666a.667.667 0 01.667.667l.667 10a.667.667 0 01-1.333 0l-.667-10a.667.667 0 01.666-.667zm9.6-4h-2.936V1.333C10.667.322 10.34 0 9.333 0h-4a1.166 1.166 0 00-1.33 1.333v1.335H1.067a1.035 1.035 0 00-1.067 1 1.035 1.035 0 001.067 1h12.536a1.035 1.035 0 001.067-1 1.035 1.035 0 00-1.067-1zm-4.267 0h-4V1.333h4v1.335z" _fill="#ec3237" fill-rule="evenodd"/>'
  }
})
